import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reducers from "./reducers";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { legacy_createStore as createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
const middlewares = [thunk];
const store = createStore(reducers, applyMiddleware(...middlewares));
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter
    future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
  >
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
);
